import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
  AppBar,
  Card,
  CardContent,
  Grid,
  Paper,
  Tab,
  Tabs,
} from '@material-ui/core';
import { TabContainer } from '../../../components/custom-tab-container/custom-tab-container';
import FormFieldsTabClientDetailsTabsReferralConditions from './tab-conditions/tab-referral-conditions';
import FormFieldsTabClientDetailsTabsClientConditions from './tab-conditions/tab-client-conditions';
import FormFieldsTabClientDetailsTabsReferral from './tab-referral/tab-referral';
class FormFieldsTabClientDetails extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      headerTabs: 0,
    };
  }  
  handleChangeClientDetailsHeader = (event, value) => {
    event.persist();
    this.setState({ headerTabs: value });
  }
  render() {
    return (
      <div>
        <Paper >
          <Card>
            <CardContent>
              <Grid container spacing={3}>
                <AppBar position="static" color="default">
                  <Tabs
                    value={this.state.headerTabs}
                    onChange={this.handleChangeClientDetailsHeader}
                    indicatorColor="primary"
                    textColor="primary"                    
                    variant="scrollable"
                                                                            // scrollButtons="auto"
                    scrollButtons="on"
                  >
                    <Tab label="Referral" />
                    <Tab label="Referral Conditions" />

                    {this.props.form !== 'ReferralEditForm' ? 
                      <Tab label="Client Conditions" />
                    : null }
                  </Tabs>
                </AppBar>

                {this.state.headerTabs === 0 && <TabContainer>
                  <FormFieldsTabClientDetailsTabsReferral
                    locked={this.props.locked}
                    initialValues={this.props.referralMode === 0 ? this.state.referralEntry : this.props.referralEntry}
                    // referralsourcesList={this.props.referralsourcesList.referralsources}
                    referralsourcesList={this.props.referralsourcesList}
                  />
                </TabContainer>} 

                {this.state.headerTabs === 1 && <TabContainer>
                  <FormFieldsTabClientDetailsTabsReferralConditions 
                    locked={ (!this.props.locked && this.props.form) !== 'ReferralEditForm' ? true : false }
                    initialValues={this.props.referralMode === 0 ? this.state.referralEntry : this.props.referralEntry}
                  />
                </TabContainer>}

                {this.props.form !== 'ReferralEditForm' ? 
                <>
                  {this.state.headerTabs === 2 && <TabContainer>
                      <FormFieldsTabClientDetailsTabsClientConditions 
                        locked={this.props.locked}
                        initialValues={this.props.clientMode === 0 ? this.state.clientEntry : this.props.clientEntry}
                      />
                    </TabContainer>}
                </>
                : null }

              </Grid>
            </CardContent>
          </Card>
        </Paper>
      </div>

    );
  }
}
FormFieldsTabClientDetails.propTypes = {
  /*** fix make required */
  locked: PropTypes.bool,
  /*** fix make required */
  referralsourcesList: PropTypes.array,
};
export default FormFieldsTabClientDetails;